import { MetricSource } from "@/features/Metrics/Metrics.types";
import clsx from "clsx";
import { showDataSourcesAtom } from "../state";
import { useAtomValue } from "jotai";

export const enum DataSource {
    LEGACY_BACKEND = "legacy-backend",
    SFDC = "sfdc",
    MEMO_TEXT = "memo-text",
}

export const DATA_SOURCES = [
    DataSource.LEGACY_BACKEND,
    DataSource.SFDC,
    DataSource.MEMO_TEXT,
    MetricSource.FINANCE_API,
    MetricSource.FINANCE_LAB,
] as const;

export const DATA_SOURCE_COLORS = {
    [MetricSource.FINANCE_API]: "text-blue-500",
    [DataSource.LEGACY_BACKEND]: "text-cyan-500",
    [DataSource.SFDC]: "text-green-500",
    [MetricSource.FINANCE_LAB]: "text-purple-500",
    [DataSource.MEMO_TEXT]: "text-orange-500",
} as const;

export const DATA_SOURCE_LABELS = {
    [MetricSource.FINANCE_API]: "Finance API",
    [DataSource.LEGACY_BACKEND]: "Legacy Backend",
    [DataSource.SFDC]: "SFDC",
    [MetricSource.FINANCE_LAB]: "Finance Lab",
    [DataSource.MEMO_TEXT]: "Memo Text LLM",
} as const;

export const SourceTag = ({
    source,
    fieldName,
}: {
    source?: MetricSource | DataSource | null;
    fieldName?: string;
}) => {
    const showSources = useAtomValue(showDataSourcesAtom);

    if (!source || !showSources) return null;

    const label = DATA_SOURCE_LABELS[source];

    return (
        <span className={clsx(DATA_SOURCE_COLORS[source], "lozenge")}>
            {`${label} ${fieldName ? `- ${fieldName}` : ""}`}
        </span>
    );
};
